<div class="productTabHeader">
    <table style="float: right" *ngIf="tabs.length > 1">
        <tr class="tabsHeadingRow">
            <td *ngFor="let tab of tabs" [ngClass]="{ tabHeading: tab.Id!==activeTabId, tabHeadingActive: tab.Id===activeTabId}">
                <a id="{{tab.Id}}" href="javascript:void(0)" (click)="showTab(tab.Id)">{{tab.Title}}</a>
            </td>
        </tr>
    </table>
</div>
